module.exports = __webpack_public_path__ + "static/media/editBlueIcon.20c67356.svg";